import { IconApplicants } from '@components/icons/applicants';
import { IconJob } from '@components/icons/job';
import { IconMessages } from '@components/icons/messages';
import { IconOnboarding } from '@components/icons/onboarding';
import { isNotFalse } from '@utils/types';

import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

const iconSize = 16;

export const useNavigationItems = () => {
  const { t } = useStore();
  const { hasRolePermission } = usePermissions();

  return [
    hasRolePermission('jobs:view') && {
      icon: <IconJob size={iconSize} />,
      path: '/jobs',
      label: t('navigation.jobs'),
    },
    hasRolePermission('applicants:view') && {
      icon: <IconApplicants size={iconSize} />,
      path: '/applicants',
      label: t('navigation.applicants'),
    },
    hasRolePermission('applicants:view') && {
      icon: <IconOnboarding size={iconSize} />,
      path: '/onboarding',
      label: t('navigation.onboarding'),
    },
    hasRolePermission('applicants:view') && {
      icon: <IconMessages size={iconSize} />,
      path: '/messages',
      label: t('navigation.messages'),
    },
  ].filter(isNotFalse);
};
